'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const mediator = require('./../../core/mediator');

require('jquery-ui/ui/widgets/draggable');
require('jquery-ui/ui/widgets/droppable');

const eventCallback = function(eventName, context, type, event, ui, $element) {
    mediator.publish('on:' + type + eventName + ':' + context, {'event': event, 'ui': ui, '$element': $element});
};

const buildOption = function(context, option, events, type) {
    context = context || 'block';
    option = option || {};
    events = events || [];

    _.forEach(events, function(eventName) {
        option[eventName] = function(event, ui) {
            eventCallback(eventName, context, type, event, ui, jQuery(this));
        };
    });

    return option;
};

module.exports.draggable = function(selector, context, option) {
    let events = ['create', 'drag', 'start', 'stop'];

    jQuery(selector).draggable(buildOption(context, option, events, 'drag'));
};

module.exports.droppable = function(selector, context, option) {
    let events = ['activate', 'create', 'deactivate', 'drop', 'out', 'over'];

    jQuery(selector).droppable(buildOption(context, option, events, 'drop'));
};
